import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CreditCardIcon, PhoneIcon, TruckIcon, CalendarIcon, ClockIcon, ChevronRightIcon, CheckIcon } from 'lucide-react';
// Sample cart items (same as in Cart.tsx)
const cartItems = [{
  id: '1',
  name: 'Elegant Rose Bouquet',
  price: 3500,
  image: 'https://images.unsplash.com/photo-1561181286-d3fee3785613?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  quantity: 1,
  color: 'Red',
  size: 'Medium'
}, {
  id: '3',
  name: 'Sunshine Sunflower Arrangement',
  price: 4200,
  image: 'https://images.unsplash.com/photo-1593106410242-b3c438e8e012?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  quantity: 2,
  size: 'Large'
}, {
  id: 'featured-1',
  name: 'Premium Rose Collection',
  price: 5800,
  image: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  quantity: 1,
  color: 'Pink',
  size: 'Deluxe (24 stems)',
  vase: 'Clear Glass Vase (+KES 1,500)'
}];
export function Checkout() {
  const [step, setStep] = useState(1);
  const [deliveryMethod, setDeliveryMethod] = useState('standard');
  const [paymentMethod, setPaymentMethod] = useState('mpesa');
  const [deliveryDate, setDeliveryDate] = useState('');
  const [deliveryTime, setDeliveryTime] = useState('morning');
  const [specialInstructions, setSpecialInstructions] = useState('');
  const [includeCard, setIncludeCard] = useState(false);
  const [cardMessage, setCardMessage] = useState('');
  // Form data
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: 'Nairobi',
    postalCode: '',
    saveInfo: true
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      checked
    } = e.target;
    setFormData({
      ...formData,
      [name]: checked
    });
  };
  const nextStep = () => {
    setStep(step + 1);
    window.scrollTo(0, 0);
  };
  const prevStep = () => {
    setStep(step - 1);
    window.scrollTo(0, 0);
  };
  // Calculate order summary
  const subtotal = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
  const shipping = deliveryMethod === 'express' ? 500 : 350;
  const total = subtotal + shipping + (includeCard ? 200 : 0);
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-558">
      <Header data-id="element-559" />
      <main className="flex-grow py-12" data-id="element-560">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-561">
          <div className="mb-8" data-id="element-562">
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-563">Checkout</h1>
            <nav className="mt-4" data-id="element-564">
              <ol className="flex items-center space-x-2 md:space-x-4" data-id="element-565">
                <li className="flex items-center" data-id="element-566">
                  <span className={`flex items-center justify-center w-8 h-8 rounded-full ${step >= 1 ? 'bg-emerald-600 text-white' : 'bg-gray-200 text-gray-600'}`} data-id="element-567">
                    {step > 1 ? <CheckIcon className="h-5 w-5" data-id="element-568" /> : 1}
                  </span>
                  <span className="ml-2 text-sm font-medium text-gray-900" data-id="element-569">
                    Shipping
                  </span>
                </li>
                <li className="flex items-center" data-id="element-570">
                  <ChevronRightIcon className="h-4 w-4 text-gray-400 mx-1" data-id="element-571" />
                  <span className={`flex items-center justify-center w-8 h-8 rounded-full ${step >= 2 ? 'bg-emerald-600 text-white' : 'bg-gray-200 text-gray-600'}`} data-id="element-572">
                    {step > 2 ? <CheckIcon className="h-5 w-5" data-id="element-573" /> : 2}
                  </span>
                  <span className="ml-2 text-sm font-medium text-gray-900" data-id="element-574">
                    Delivery
                  </span>
                </li>
                <li className="flex items-center" data-id="element-575">
                  <ChevronRightIcon className="h-4 w-4 text-gray-400 mx-1" data-id="element-576" />
                  <span className={`flex items-center justify-center w-8 h-8 rounded-full ${step >= 3 ? 'bg-emerald-600 text-white' : 'bg-gray-200 text-gray-600'}`} data-id="element-577">
                    {step > 3 ? <CheckIcon className="h-5 w-5" data-id="element-578" /> : 3}
                  </span>
                  <span className="ml-2 text-sm font-medium text-gray-900" data-id="element-579">
                    Payment
                  </span>
                </li>
                <li className="flex items-center" data-id="element-580">
                  <ChevronRightIcon className="h-4 w-4 text-gray-400 mx-1" data-id="element-581" />
                  <span className={`flex items-center justify-center w-8 h-8 rounded-full ${step >= 4 ? 'bg-emerald-600 text-white' : 'bg-gray-200 text-gray-600'}`} data-id="element-582">
                    4
                  </span>
                  <span className="ml-2 text-sm font-medium text-gray-900" data-id="element-583">
                    Confirmation
                  </span>
                </li>
              </ol>
            </nav>
          </div>
          <div className="lg:grid lg:grid-cols-12 lg:gap-x-12" data-id="element-584">
            <div className="lg:col-span-7" data-id="element-585">
              {/* Step 1: Shipping Information */}
              {step === 1 && <div className="bg-white rounded-lg shadow-md p-6" data-id="element-586">
                  <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-587">
                    Shipping Information
                  </h2>
                  <div className="space-y-4" data-id="element-588">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-589">
                      <div data-id="element-590">
                        <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-591">
                          First Name*
                        </label>
                        <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleInputChange} required className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-592" />
                      </div>
                      <div data-id="element-593">
                        <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-594">
                          Last Name*
                        </label>
                        <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleInputChange} required className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-595" />
                      </div>
                    </div>
                    <div data-id="element-596">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-597">
                        Email Address*
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-598" />
                    </div>
                    <div data-id="element-599">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-600">
                        Phone Number*
                      </label>
                      <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} required className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-601" />
                    </div>
                    <div data-id="element-602">
                      <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-603">
                        Delivery Address*
                      </label>
                      <input type="text" id="address" name="address" value={formData.address} onChange={handleInputChange} required className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-604" />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-605">
                      <div data-id="element-606">
                        <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-607">
                          City/Town*
                        </label>
                        <select id="city" name="city" value={formData.city} onChange={handleInputChange} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-608">
                          <option value="Nairobi" data-id="element-609">Nairobi</option>
                          <option value="Mombasa" data-id="element-610">Mombasa</option>
                          <option value="Kisumu" data-id="element-611">Kisumu</option>
                          <option value="Nakuru" data-id="element-612">Nakuru</option>
                          <option value="Eldoret" data-id="element-613">Eldoret</option>
                        </select>
                      </div>
                      <div data-id="element-614">
                        <label htmlFor="postalCode" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-615">
                          Postal Code
                        </label>
                        <input type="text" id="postalCode" name="postalCode" value={formData.postalCode} onChange={handleInputChange} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-616" />
                      </div>
                    </div>
                    <div className="flex items-center mt-4" data-id="element-617">
                      <input id="saveInfo" name="saveInfo" type="checkbox" checked={formData.saveInfo} onChange={handleCheckboxChange} className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300 rounded" data-id="element-618" />
                      <label htmlFor="saveInfo" className="ml-2 block text-sm text-gray-900" data-id="element-619">
                        Save this information for next time
                      </label>
                    </div>
                  </div>
                  <div className="mt-8 flex justify-end" data-id="element-620">
                    <button type="button" onClick={nextStep} className="bg-emerald-600 text-white py-2 px-4 rounded-md hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500" data-id="element-621">
                      Continue to Delivery
                    </button>
                  </div>
                </div>}
              {/* Step 2: Delivery Options */}
              {step === 2 && <div className="bg-white rounded-lg shadow-md p-6" data-id="element-622">
                  <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-623">
                    Delivery Options
                  </h2>
                  <div className="space-y-6" data-id="element-624">
                    <div data-id="element-625">
                      <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-626">
                        Delivery Method
                      </h3>
                      <div className="space-y-3" data-id="element-627">
                        <label className={`flex items-center p-4 border rounded-md cursor-pointer ${deliveryMethod === 'standard' ? 'border-emerald-500 bg-emerald-50' : 'border-gray-300'}`} data-id="element-628">
                          <input type="radio" name="deliveryMethod" value="standard" checked={deliveryMethod === 'standard'} onChange={() => setDeliveryMethod('standard')} className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300" data-id="element-629" />
                          <div className="ml-3 flex items-center justify-between flex-1" data-id="element-630">
                            <div data-id="element-631">
                              <p className="text-sm font-medium text-gray-900" data-id="element-632">
                                Standard Delivery
                              </p>
                              <p className="text-sm text-gray-500" data-id="element-633">
                                Delivery within 24 hours in Nairobi
                              </p>
                            </div>
                            <div className="text-sm font-medium text-gray-900" data-id="element-634">
                              KES 350
                            </div>
                          </div>
                        </label>
                        <label className={`flex items-center p-4 border rounded-md cursor-pointer ${deliveryMethod === 'express' ? 'border-emerald-500 bg-emerald-50' : 'border-gray-300'}`} data-id="element-635">
                          <input type="radio" name="deliveryMethod" value="express" checked={deliveryMethod === 'express'} onChange={() => setDeliveryMethod('express')} className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300" data-id="element-636" />
                          <div className="ml-3 flex items-center justify-between flex-1" data-id="element-637">
                            <div data-id="element-638">
                              <p className="text-sm font-medium text-gray-900" data-id="element-639">
                                Express Delivery
                              </p>
                              <p className="text-sm text-gray-500" data-id="element-640">
                                Same-day delivery (order before 2PM)
                              </p>
                            </div>
                            <div className="text-sm font-medium text-gray-900" data-id="element-641">
                              KES 500
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div data-id="element-642">
                      <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-643">
                        Preferred Delivery Date
                      </h3>
                      <div className="flex items-center" data-id="element-644">
                        <CalendarIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-645" />
                        <input type="date" value={deliveryDate} onChange={e => setDeliveryDate(e.target.value)} min={new Date().toISOString().split('T')[0]} className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-646" />
                      </div>
                    </div>
                    <div data-id="element-647">
                      <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-648">
                        Preferred Time of Delivery
                      </h3>
                      <div className="flex items-center space-x-4" data-id="element-649">
                        <ClockIcon className="h-5 w-5 text-gray-400" data-id="element-650" />
                        <div className="space-x-4" data-id="element-651">
                          <label className="inline-flex items-center" data-id="element-652">
                            <input type="radio" name="deliveryTime" value="morning" checked={deliveryTime === 'morning'} onChange={() => setDeliveryTime('morning')} className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300" data-id="element-653" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-654">
                              Morning (8AM - 12PM)
                            </span>
                          </label>
                          <label className="inline-flex items-center" data-id="element-655">
                            <input type="radio" name="deliveryTime" value="afternoon" checked={deliveryTime === 'afternoon'} onChange={() => setDeliveryTime('afternoon')} className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300" data-id="element-656" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-657">
                              Afternoon (12PM - 5PM)
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div data-id="element-658">
                      <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-659">
                        Special Instructions (Optional)
                      </h3>
                      <textarea rows={3} value={specialInstructions} onChange={e => setSpecialInstructions(e.target.value)} placeholder="Add any special delivery instructions here..." className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-660" />
                    </div>
                    <div data-id="element-661">
                      <div className="flex items-center" data-id="element-662">
                        <input id="includeCard" type="checkbox" checked={includeCard} onChange={e => setIncludeCard(e.target.checked)} className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300 rounded" data-id="element-663" />
                        <label htmlFor="includeCard" className="ml-2 block text-sm font-medium text-gray-900" data-id="element-664">
                          Include a gift card (+KES 200)
                        </label>
                      </div>
                      {includeCard && <div className="mt-3" data-id="element-665">
                          <textarea rows={3} value={cardMessage} onChange={e => setCardMessage(e.target.value)} placeholder="Enter your gift message here..." className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-666" />
                        </div>}
                    </div>
                  </div>
                  <div className="mt-8 flex justify-between" data-id="element-667">
                    <button type="button" onClick={prevStep} className="text-emerald-600 hover:text-emerald-500 font-medium" data-id="element-668">
                      Back to Shipping
                    </button>
                    <button type="button" onClick={nextStep} className="bg-emerald-600 text-white py-2 px-4 rounded-md hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500" data-id="element-669">
                      Continue to Payment
                    </button>
                  </div>
                </div>}
              {/* Step 3: Payment */}
              {step === 3 && <div className="bg-white rounded-lg shadow-md p-6" data-id="element-670">
                  <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-671">
                    Payment Method
                  </h2>
                  <div className="space-y-6" data-id="element-672">
                    <div data-id="element-673">
                      <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-674">
                        Select a payment method
                      </h3>
                      <div className="space-y-3" data-id="element-675">
                        <label className={`flex items-center p-4 border rounded-md cursor-pointer ${paymentMethod === 'mpesa' ? 'border-emerald-500 bg-emerald-50' : 'border-gray-300'}`} data-id="element-676">
                          <input type="radio" name="paymentMethod" value="mpesa" checked={paymentMethod === 'mpesa'} onChange={() => setPaymentMethod('mpesa')} className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300" data-id="element-677" />
                          <div className="ml-3 flex items-center justify-between flex-1" data-id="element-678">
                            <div className="flex items-center" data-id="element-679">
                              <PhoneIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-680" />
                              <p className="text-sm font-medium text-gray-900" data-id="element-681">
                                M-Pesa
                              </p>
                            </div>
                          </div>
                        </label>
                        <label className={`flex items-center p-4 border rounded-md cursor-pointer ${paymentMethod === 'card' ? 'border-emerald-500 bg-emerald-50' : 'border-gray-300'}`} data-id="element-682">
                          <input type="radio" name="paymentMethod" value="card" checked={paymentMethod === 'card'} onChange={() => setPaymentMethod('card')} className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300" data-id="element-683" />
                          <div className="ml-3 flex items-center justify-between flex-1" data-id="element-684">
                            <div className="flex items-center" data-id="element-685">
                              <CreditCardIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-686" />
                              <p className="text-sm font-medium text-gray-900" data-id="element-687">
                                Credit/Debit Card
                              </p>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    {paymentMethod === 'mpesa' && <div className="bg-gray-50 p-4 rounded-md" data-id="element-688">
                        <p className="text-sm text-gray-700 mb-2" data-id="element-689">
                          You'll receive an M-Pesa payment prompt on your phone
                          after placing the order.
                        </p>
                        <div className="flex items-center" data-id="element-690">
                          <PhoneIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-691" />
                          <input type="tel" value={formData.phone} readOnly className="border border-gray-300 rounded-md px-3 py-2 bg-white focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-692" />
                        </div>
                      </div>}
                    {paymentMethod === 'card' && <div className="space-y-4" data-id="element-693">
                        <div data-id="element-694">
                          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-695">
                            Card Number
                          </label>
                          <input type="text" placeholder="1234 5678 9012 3456" className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-696" />
                        </div>
                        <div className="grid grid-cols-2 gap-4" data-id="element-697">
                          <div data-id="element-698">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-699">
                              Expiry Date
                            </label>
                            <input type="text" placeholder="MM/YY" className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-700" />
                          </div>
                          <div data-id="element-701">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-702">
                              CVC
                            </label>
                            <input type="text" placeholder="123" className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-703" />
                          </div>
                        </div>
                        <div data-id="element-704">
                          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-705">
                            Name on Card
                          </label>
                          <input type="text" placeholder="John Doe" className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-706" />
                        </div>
                      </div>}
                  </div>
                  <div className="mt-8 flex justify-between" data-id="element-707">
                    <button type="button" onClick={prevStep} className="text-emerald-600 hover:text-emerald-500 font-medium" data-id="element-708">
                      Back to Delivery
                    </button>
                    <button type="button" onClick={nextStep} className="bg-emerald-600 text-white py-2 px-4 rounded-md hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500" data-id="element-709">
                      Place Order
                    </button>
                  </div>
                </div>}
              {/* Step 4: Confirmation */}
              {step === 4 && <div className="bg-white rounded-lg shadow-md p-6 text-center" data-id="element-710">
                  <div className="flex justify-center mb-4" data-id="element-711">
                    <div className="h-16 w-16 bg-emerald-100 rounded-full flex items-center justify-center" data-id="element-712">
                      <CheckIcon className="h-8 w-8 text-emerald-600" data-id="element-713" />
                    </div>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-714">
                    Thank You For Your Order!
                  </h2>
                  <p className="text-gray-600 mb-6" data-id="element-715">
                    Your order has been placed successfully. We've sent a
                    confirmation to your email.
                  </p>
                  <div className="bg-gray-50 p-4 rounded-md text-left mb-6" data-id="element-716">
                    <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-717">
                      Order Details
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-718">
                      Order Number:{' '}
                      <span className="font-medium" data-id="element-719">
                        MD-{Math.floor(Math.random() * 10000)}
                      </span>
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-720">
                      Order Date:{' '}
                      <span className="font-medium" data-id="element-721">
                        {new Date().toLocaleDateString()}
                      </span>
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-722">
                      Payment Method:{' '}
                      <span className="font-medium" data-id="element-723">
                        {paymentMethod === 'mpesa' ? 'M-Pesa' : 'Credit/Debit Card'}
                      </span>
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-724">
                      Delivery Date:{' '}
                      <span className="font-medium" data-id="element-725">
                        {deliveryDate || 'Not specified'}
                      </span>
                    </p>
                  </div>
                  <div className="flex justify-center space-x-4" data-id="element-726">
                    <Link to="/" className="bg-emerald-600 text-white py-2 px-4 rounded-md hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500" data-id="element-727">
                      Return to Home
                    </Link>
                    <button type="button" className="border border-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500" data-id="element-728">
                      Track Order
                    </button>
                  </div>
                </div>}
            </div>
            {/* Order Summary */}
            <div className="lg:col-span-5 mt-8 lg:mt-0" data-id="element-729">
              <div className="bg-white rounded-lg shadow-md p-6 sticky top-20" data-id="element-730">
                <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-731">
                  Order Summary
                </h2>
                <div className="flow-root" data-id="element-732">
                  <ul className="-my-4 divide-y divide-gray-200" data-id="element-733">
                    {cartItems.map(item => <li key={item.id} className="py-4 flex" data-id="element-734">
                        <div className="flex-shrink-0 w-16 h-16" data-id="element-735">
                          <img src={item.image} alt={item.name} className="w-full h-full object-cover object-center rounded-md" data-id="element-736" />
                        </div>
                        <div className="ml-4 flex-1" data-id="element-737">
                          <div className="flex justify-between" data-id="element-738">
                            <h3 className="text-sm font-medium text-gray-900" data-id="element-739">
                              {item.name}
                            </h3>
                            <p className="text-sm font-medium text-gray-900" data-id="element-740">
                              KES{' '}
                              {(item.price * item.quantity).toLocaleString()}
                            </p>
                          </div>
                          <div className="mt-1 flex text-sm text-gray-500" data-id="element-741">
                            {item.color && <p className="mr-2" data-id="element-742">{item.color}</p>}
                            {item.size && <p data-id="element-743">{item.size}</p>}
                          </div>
                          <p className="mt-1 text-sm text-gray-500" data-id="element-744">
                            Qty {item.quantity}
                          </p>
                        </div>
                      </li>)}
                  </ul>
                </div>
                <div className="border-t border-gray-200 mt-6 pt-6 space-y-4" data-id="element-745">
                  <div className="flex justify-between" data-id="element-746">
                    <p className="text-sm text-gray-600" data-id="element-747">Subtotal</p>
                    <p className="text-sm font-medium text-gray-900" data-id="element-748">
                      KES {subtotal.toLocaleString()}
                    </p>
                  </div>
                  <div className="flex justify-between" data-id="element-749">
                    <p className="text-sm text-gray-600" data-id="element-750">Shipping</p>
                    <p className="text-sm font-medium text-gray-900" data-id="element-751">
                      KES {shipping.toLocaleString()}
                    </p>
                  </div>
                  {includeCard && <div className="flex justify-between" data-id="element-752">
                      <p className="text-sm text-gray-600" data-id="element-753">Gift Card</p>
                      <p className="text-sm font-medium text-gray-900" data-id="element-754">
                        KES 200
                      </p>
                    </div>}
                  <div className="flex justify-between border-t border-gray-200 pt-4" data-id="element-755">
                    <p className="text-base font-medium text-gray-900" data-id="element-756">Total</p>
                    <p className="text-base font-bold text-emerald-600" data-id="element-757">
                      KES {total.toLocaleString()}
                    </p>
                  </div>
                </div>
                <div className="mt-6" data-id="element-758">
                  <div className="flex items-start" data-id="element-759">
                    <TruckIcon className="h-5 w-5 text-emerald-600 flex-shrink-0 mt-0.5 mr-2" data-id="element-760" />
                    <div data-id="element-761">
                      <h4 className="text-sm font-medium text-gray-900" data-id="element-762">
                        {deliveryMethod === 'express' ? 'Express Delivery' : 'Standard Delivery'}
                      </h4>
                      <p className="mt-1 text-xs text-gray-500" data-id="element-763">
                        {deliveryMethod === 'express' ? 'Same-day delivery for orders placed before 2PM' : 'Delivery within 24 hours in Nairobi'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-764" />
    </div>;
}